<template>
  <div>
    <v-breadcrumbs v-if="resource_type" :items="breadcrumbsItems">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
            href="#"
            :disabled="item.disabled"
            @click="openBreadcrumbsUrl(item)"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <v-data-table v-if="!displayParameters"
      :headers="headers"
      :items="items"
      :loading="loading"
      fixed-header
      no-data-text="Нет моделей для отображения"
      hide-default-footer
      disable-pagination
      dense
    >
      <template v-slot:item="{ item }">
        <tr @click="showParameters(item)" class="link-row">
          <td>{{ item.name }}</td>
          <td>{{ item.source.name }}</td>
          <td>{{ item.resource_type.name }}</td>
          <td>{{ item.external_model.model_name }}</td>
          <td align="center"><v-icon v-if="item.has_storage" color="green">check</v-icon></td>
          <td align="right">{{ item.counter_width }}</td>
          <td align="right">{{ item.decimal_places }}</td>
          <td align="right">{{ item.remark }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'CountersModels',
  data () {
    return {
      totalItems: 0,
      items: [],
      loading: true,
      headers: [
        {
          text: 'Наименование',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Источник данных',
          align: 'left',
          sortable: true,
          value: 'source'
        },
        {
          text: 'Тип энергоресурса',
          align: 'left',
          sortable: true,
          value: 'resource_type'
        },
        {
          text: 'API счетчика',
          align: 'left',
          sortable: false,
          value: 'external_model'
        },
        {
          text: 'Наличие хранимых данных',
          align: 'left',
          sortable: false,
          value: 'has_storage'
        },
        {
          text: 'Разрядность счётчика',
          align: 'right',
          sortable: false,
          value: 'counter_width'
        },
        {
          text: 'Знаков после запятой',
          align: 'right',
          sortable: false,
          value: 'decimal_places'
        },
        { text: 'Примечание', value: 'remark' }
      ],
      modelId: null,
      displayParameters: false,
      counter_model_api: null,
      resource_type: null,
      breadcrumbsItems: [
        {
          text: 'Ресурс',
          disabled: false,
          href: 'counters_resource'
        }
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  mounted () {
    this.counter_model_api = this.$route.query.counter_model_api
    this.resource_type = this.$route.query.resource_type
    this.getItemsApi()
    this.fillBreadcrumb()
  },
  methods: {
    getItemsApi () {
      this.loading = true
      var url = `/api/counters_models/`
      if (this.counter_model_api) {
        url += `?counter_model_api=${this.counter_model_api}`
      }
      this.axios.get(url)
        .then((response) => {
          this.items = response.data.results
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    fillBreadcrumb () {
      if (!this.resource_type) {
        return
      }
      this.axios.get(`api/resources_types/${this.resource_type}/`)
        .then((response) => {
          this.breadcrumbsItems.push(
            {
              text: response.data.name,
              disabled: false,
              href: 'counters_models_api?resource_type=' + this.resource_type
            }
          )
          this.axios.get(`api/counters_api/${this.counter_model_api}/`)
            .then((modelApiResponse) => {
              this.breadcrumbsItems.push(
                {
                  text: modelApiResponse.data.name,
                  disabled: true
                }
              )
            })
        })
    },
    openBreadcrumbsUrl (item) {
      this.$router.push({ path: item.href })
    },
    showParameters (item) {
      this.$router.push({ path: 'counter_model_parameters',
        query: {
          counter_model: item.model_id
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/references/CountersModels.vue